import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import { InfoTooltip } from '../../molecules/InfoTooltip';
import { getCurrentAgreementRowText } from './agreementText';
import type { BatchAgreement } from './types';
import styles from './BatchAgreements.module.scss';

interface AgreementSummaryListProps {
  batchAgreements: BatchAgreement[];
  userHasMultiplePaAgreements: boolean;
  showOverageIndicator: boolean;
}

const AgreementSummaryList: React.FC<AgreementSummaryListProps> = ({
  batchAgreements,
  userHasMultiplePaAgreements,
  showOverageIndicator,
}) => {
  const t = useTranslations();

  return (
    <div
      className={styles.agreementSummary}
      data-testid="batch-agreements"
    >
      {batchAgreements.map((agreement) => (
        <p
          key={agreement.id}
          data-testid="agreement-details"
        >
          {getCurrentAgreementRowText(
            agreement,
            t,
            userHasMultiplePaAgreements,
            showOverageIndicator
          )}
          {showOverageIndicator && agreement.overageReached && (
            <InfoTooltip
              content={t('overage_tooltip')}
              tooltipClassName={styles.overageTooltip}
            />
          )}
        </p>
      ))}
    </div>
  );
};

export default AgreementSummaryList;
